<template>
  <v-dialog max-width="454px" :value="open" @click:outside="$emit('close')">
    <v-card class="pa-6 d-flex flex-column align-center justify-start">
      <p class="font-bold py-4 mb-0 h6 headline w-100">
        {{ $t('common.great_title') }}
      </p>
      <p
        class="message text-start mb-10 blue-grey--text text--darken-1 font-size-16"
        v-html="
          $sanitize($t('assignments.finding_rev_info_modal_message'), {
            allowedTags: ['b'],
          })
        "
      />
      <v-card-actions class="d-flex justify-end pa-0 w-100">
        <Button
          color="primary"
          :text="$t('common.button.close')"
          @click="$emit('close')"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import illustration from '@/assets/rev/rever_cycle.svg'
import Button from '@/components/UI/Button'
import confetti from 'canvas-confetti'
import mixin from '@/mixins/mixin.vue'

export default {
  props: {
    open: Boolean,
  },
  components: {
    Button,
  },
  mixins: [mixin],
  data() {
    return {
      illustration,
    }
  },
  mounted() {
    if (this.open) return this.setconfetti()
  },

  methods: {
    setconfetti() {
      confetti({
        particleCount: 200,
        spread: 90,
        origin: { y: 1 },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.message {
  white-space: pre-line;
}
</style>
